import { useGetApiV1PersonIdAttachmentsClassStudents } from '@/shared/api/generated';

export interface ClassStudentOption {
  readonly id: number;
  readonly displayName: string;
}

/**
 * Hook para listar as turmas (ClassStudent) de uma pessoa para o dropdown de upload.
 *
 * @param personId - ID da pessoa
 * @returns Lista mapeada de turmas e estado de loading
 *
 * @example
 * ```tsx
 * const { options, isLoading } = useClassStudents(personId);
 * ```
 */
export function useClassStudents(personId: number) {
  const query = useGetApiV1PersonIdAttachmentsClassStudents(personId);

  const options: readonly ClassStudentOption[] = (query.data ?? []).map(item => ({
    id: item.id ?? 0,
    displayName: item.displayName ?? item.name ?? '',
  }));

  return {
    options,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
